import { supabase } from "../supabase/supabaseClient";

export const getNotesForPlayer = async (scoutId, playerId) => {
    return await supabase
        .from("notes")
        .select("id, note, created_at, updated_at")
        .eq("scout_id", scoutId)
        .eq("player_id", playerId)
        .order("updated_at", { ascending: false });
};

export const createNote = async (scoutId, playerId, note) => {
    return await supabase
        .from("notes")
        .insert([{ scout_id: scoutId, player_id: playerId, note }])
        .select()
        .single();
};

export const updateNote = async (noteId, note) => {
    return await supabase
        .from("notes")
        .update({ note })
        .eq("id", noteId)
        .select()
        .single();
};

export const deleteNote = async (noteId) => {
    return await supabase
        .from("notes")
        .delete()
        .eq("id", noteId);
};
